<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24"></a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('供水流域')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ type: 'radio', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-wrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <div class="flex justify-center" v-else>
            <img
              :src="getImgView(text)"
              alt
              class="w-40px h-40px"
              style="max-width:80px;font-size: 12px;font-style: italic;"
            />
          </div>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>

      <ModelPointList :deviceData="processData" idType="devProcessId" v-if="selectionRows.length > 0" />
      <a-empty style="margin-bottom: 12px;" v-else>
        <div slot="description">
          <span>没有选择流域</span>
        </div>
      </a-empty>
    </div>

    <dev-process-modal @ok="modalFormOk" ref="modalForm"></dev-process-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevProcessModal from './modules/DevProcessModal'
  import { DragTableMixin } from '@/mixins/DragTableMixin'
  import ModelPointList from '@/views/monitor/points/IotModelPointsList.vue'

  export default {
    name: 'DevProcessList',
    mixins: [DragTableMixin, JeecgListMixin, mixinDevice],
    components: {
      DevProcessModal,
      ModelPointList
    },
    data () {
      const forceNowrap = text => <span class="j-force-nowrap">{text}</span>
      return {
        description: '设备类型管理页面',
        isorter: {
          column: 'sort',
          order: 'asc'
        },
        listPagination: {
          pageSize: 50,
          pageSizeOptions: ['50', '100', '200', '300']
        },
        // 表头
        columns: [
          {
            title: '供水流域',
            align: 'center',
            dataIndex: 'processName'
          },
          {
            title: '照片',
            align: 'center',
            dataIndex: 'pictureObjId',
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title: '说明',
            align: 'left',
            width: '66%',
            dataIndex: 'description'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/device/devProcess/list',
          delete: '/device/devProcess/delete',
          deleteBatch: '/device/devProcess/deleteBatch',
          exportXlsUrl: '/device/devProcess/exportXls',
          importExcelUrl: '/device/devProcess/importExcel',
          sort: '/device/devProcess/editSort'
        },
        dictOptions: {},
        superFieldList: [],
        disableMixinCreated: false
      }
    },
    async created () {
      this.getSuperFieldList()
      //    await this.loadData()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      },
      processData () {
        return this.selectionRows.length > 0 ? { ...this.selectionRows[0] } : {}
        //  return { ...this.selectionRows[0] }
      }
    },
    methods: {
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'processName', text: '工艺名称' })
        fieldList.push({ type: 'string', value: 'description', text: '说明' })
        fieldList.push({ type: 'int', value: 'tenantId', text: '租户id' })
        fieldList.push({ type: 'string', value: 'orgId', text: '公司id' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
